import { AutogenLayoutSettlementMessages } from "./autogen/AutogenLayoutSettlementMessages";
import { DataSourceAction, DataSourceExecutionEvent } from "@mcleod/components";
import { FieldUpdateEvent } from "@mcleod/core";

export class SettlementMessages extends AutogenLayoutSettlementMessages {
    onLoad(): void | Promise<void> {
        this.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.getAction() === DataSourceAction.SEARCH) {
                if (this.activeRow == null) return;
                this.textboxCompanyDrNote.required = !this.activeRow.isNull("company_end_date");
                this.textboxOwnerDrNote.required = !this.activeRow.isNull("owner_end_date");
                this.activeRow.addAfterFieldUpdateListener((event: FieldUpdateEvent) => {
                    if (event.fieldName === "company_end_date" || event.fieldName === "owner_end_date") {
                        this.textboxCompanyDrNote.required = !this.activeRow.isNull("company_end_date");
                        this.textboxOwnerDrNote.required = !this.activeRow.isNull("owner_end_date");
                    }
                });
            }
        });
    }
}
